var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":_vm.logout}},[_vm._v("Logout")])
}
var staticRenderFns = []

export { render, staticRenderFns }